import { CloseIconData, HelpIconData } from "@meiden-connect/material-symbols";
import { Button, Icon } from "@meiden-connect/ui";
import { useState } from "react";
import { loadTipsCollapsed, saveTipsCollapsed } from "../lib/tips-preference";

// 操作 Tips パネル（画面左下固定）。
// デフォルトは折りたたみ表示（ヘルプアイコンのみ）、クリックで展開してショートカット一覧を表示する。
// 全体マップは右下、操作ヒントは左下と画面の対角に分けて重なりを避ける。
export function ShortcutTipsPanel(): JSX.Element {
  const [collapsed, setCollapsed] = useState<boolean>(() => loadTipsCollapsed());
  const toggle = (): void => {
    const next = !collapsed;
    setCollapsed(next);
    saveTipsCollapsed(next);
  };

  const toggleLabel = collapsed ? "操作ヒントを表示" : "操作ヒントを隠す";

  return (
    <aside
      aria-label="操作ヒント"
      className="canvas-shortcut-tips"
      style={{
        position: "absolute",
        left: "16px",
        bottom: "16px",
        zIndex: 10,
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        gap: "8px",
        maxWidth: "320px",
      }}
    >
      <Button
        type="button"
        aria-expanded={!collapsed}
        aria-label={toggleLabel}
        title={toggleLabel}
        onClick={toggle}
        variant="action"
      >
        <Icon d={collapsed ? HelpIconData : CloseIconData} />
      </Button>
      {!collapsed ? (
        <ul
          style={{
            margin: 0,
            padding: "12px 16px",
            listStyle: "none",
            background: "var(--color-surface)",
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius-2)",
            boxShadow: "var(--shadow-1)",
            fontSize: "12px",
            color: "var(--color-text-muted)",
            lineHeight: "1.7",
          }}
        >
          <li>ドラッグ または W/A/S/D キー: キャンバス移動</li>
          <li>Shift+W/A/S/D: 倍速で移動</li>
          <li>ホイール: 上下スクロール / Shift+ホイール: 左右</li>
          <li>Ctrl+ホイール: 拡大縮小 / Ctrl+「+」「−」: 段階ズーム</li>
          <li>Shift+ドラッグ（図形移動中）: x 軸 / y 軸を固定してまっすぐ移動</li>
          <li>Alt+ドラッグ（図形移動中）: 移動元を残して複製（ドロップ先にコピー）</li>
          <li>図形移動・複製中: 他の図形と端／中心が揃うと補助線が出て自動で整列</li>
          <li>Shift+ドラッグ（四隅ハンドル）: アスペクト比を保ったままリサイズ</li>
          <li>Ctrl+クリック: 図形を複数選択（移動・削除・コピーが可能）</li>
          <li>右クリック: 図形のロック / 最前面・最背面 / 削除メニュー</li>
          <li>Ctrl+C: 選択中の図形・テキスト・画像・リンクカードをコピー</li>
          <li>Ctrl+X: 選択中のオブジェクトを切り取り（コピーして削除）</li>
          <li>Ctrl+V: コピーしたオブジェクト / 画像 / URL をマウス位置へ貼り付け</li>
          <li>Delete / Backspace: 選択中のオブジェクトを削除</li>
          <li>Ctrl+] / Ctrl+[: 選択中オブジェクトを前面 / 背面へ移動</li>
          <li>Ctrl+Z: 自分の直前操作を元に戻す</li>
          <li>Ctrl+Y: 元に戻した自分の操作をやり直す</li>
          <li>ファイルをドラッグ&ドロップで画像/動画を配置</li>
          <li>Esc: ツール解除</li>
        </ul>
      ) : null}
    </aside>
  );
}
